import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Breadcrumb } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { ValidationMessage } from "../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../helper/helper";
import { MaxLength } from "../utils/constants/CharactersLength";
import { ErrorMessage } from "@hookform/error-message";
import { regex } from "../utils/constants/regexVariables";
import PhoneInputField from "../components/shared/FormFields/PhoneInputField";
import { contactUsApi } from "../hooks/ApisContainer/Auth";
import useToastContext from "../hooks/useToastContext";
import SuccessCheck from "../components/shared/Loader/SuccessCheck";

const ContactUs = () => {
  const notification = useToastContext();
  const navigate = useNavigate();

  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // ALL STATE
  const [phone, setPhone] = useState("");
  const [loader, setLoader] = useState(false);
  const [successContactUi, setSuccessContactUi] = useState(false);

  const onSubmit = (data) => {
    delete data.countryCode;
    const requestPayload = { ...data };

    contactUsApi(requestPayload, notification, (loading, error) => {
      setLoader(loading);
      if (!error) {
        setSuccessContactUi(true);
      }
    });
  };

  const navigateToContactForm = () => {
    window.location.reload();
  };
  const navigateToHomePage = () => {
    navigate("/");
  };

  useEffect(() => {
    if (successContactUi) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [successContactUi]);

  return (
    <div className="inner-wrapper pb-0">
      <div className="page-title mb-5">
        <div class="common-heading text-center mb-3">
          <h2>Contact Us</h2>
        </div>
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => navigate("/")} className="text-decoration-none ">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-orange">
            Contact us
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <section className="contact-us-sec">
        <Container>
          {successContactUi ? (
            <div className="wrapper mw-100 position-relative mb-5">
              <Row>
                <Col md={12}>
                  <div className="success-check">
                    <SuccessCheck />
                  </div>
                  <div className="success-page">
                    <h2 className="text-center">Thank You for Reaching Out!</h2>
                    <p className="text-center">
                      We appreciate you contacting us. Our team will get back to
                      you as soon as possible.
                    </p>
                    <p className="text-center">
                      In the meantime, feel free to explore our website for more
                      information.
                    </p>
                    <div className="text-center mt-4">
                      <button
                        className="btn-logins"
                        type="button"
                        onClick={() => navigateToHomePage()}
                        style={{ marginRight: "15px" }}
                      >
                        Back to Home
                      </button>
                      <button
                        className="btn-logins "
                        type="button"
                        onClick={() => navigateToContactForm()}
                      >
                        Submit Another Query
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <Form
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              autoComplete="off"
            >
              <Row>
                <Col md={6} className="m-auto mb-4">
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group
                        controlId="formSurname"
                        className="text-start"
                      >
                        <Form.Label className="fw-bold">First Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="First name"
                          name="firstName"
                          {...register("firstName", {
                            required: ValidationMessage.FIRST_NAME_REQUIRED,
                            validate: (value) => whiteSpaceCheck(value),
                          })}
                          maxLength={MaxLength.nameLen}
                        />
                      </Form.Group>
                      <ErrorMessage
                        errors={errors}
                        name="firstName"
                        render={({ message }) => (
                          <p className="error-message text-start py-2 px-1 text-danger">
                            {message}
                          </p>
                        )}
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group
                        controlId="formSurname"
                        className="text-start"
                      >
                        <Form.Label className="fw-bold">Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Last name"
                          name="lastName"
                          {...register("lastName", {
                            required: ValidationMessage?.LAST_NAME_REQUIRED,
                            validate: (value) => whiteSpaceCheck(value),
                          })}
                          maxLength={MaxLength.nameLen}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="lastName"
                          render={({ message }) => (
                            <p className="error-message text-start py-2 px-1 text-danger">
                              {message}
                            </p>
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group
                        controlId="formSurname"
                        className="text-start"
                      >
                        <Form.Label className="fw-bold">Email</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Email"
                          name="email"
                          {...register("email", {
                            required: ValidationMessage.EMAIL_REQUIRED,
                            pattern: {
                              value: regex.regEmail,
                              message: ValidationMessage.ENTER_VALID_EMAIL,
                            },
                          })}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="email"
                          render={({ message }) => (
                            <p className="error-message text-start py-2 px-1 text-danger">
                              {message}
                            </p>
                          )}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group
                        controlId="formSurname"
                        className="text-start"
                      >
                        <Form.Label className="fw-bold">
                          Mobile Number
                        </Form.Label>
                        <PhoneInputField
                          register={register}
                          setValue={setValue}
                          errors={errors}
                          name="mobile"
                          validationMessage={ValidationMessage}
                          regex={regex}
                          countryCode="+91"
                          initialPhone=""
                          setPhone={setPhone}
                          phone={phone}
                          className={""}
                        />
                      </Form.Group>
                      <ErrorMessage
                        errors={errors}
                        name="mobile"
                        render={({ message }) => (
                          <p className="error-message text-start py-2 px-1 text-danger">
                            {message}
                          </p>
                        )}
                      />
                    </Col>

                    <Col md={12} className="text-start">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label className="fw-bold">Message</Form.Label>

                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter your message."
                          name="message"
                          {...register("message", {
                            required: ValidationMessage.FORGOT_TO_ENTER_MESSAGE,
                            validate: (value) => whiteSpaceCheck(value),
                          })}
                          style={{ resize: "none" }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="message"
                          render={({ message }) => (
                            <p className="error-message text-start py-2 px-1 text-danger">
                              {message}
                            </p>
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12} className="text-center">
                      <Button
                        type="submit"
                        className="read-more border bg-orange  fs-5 px-3"
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Container>
      </section>
    </div>
  );
};

export default ContactUs;
